import { delayPromise } from '@tableau/vizportalclient-common-components';

import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ERROR_NOTIFYING_SERVER_RESPONSE_DELAY } from '~src/httpClient/WebHttpClientWithErrorToast';
import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/ts/services/RestApiService';

import { DataQualityCertificationContentListItem } from './DataQualityIndicator';

const deleteDataQualityCertificationConfig: JsonRestApiRequestConfig = {
  restApiVersion: '3.13',
  serverWideRequest: false,
  httpMethod: 'DELETE',
  endpoint: 'dataQualityCertifications'
};

type DeleteDataQualityCertificationsForItemsParams = {
  readonly items: ReadonlyArray<{
    readonly contentType: string;
    readonly contentLuid: string;
  }>;
}

type DeleteDataQualityCertificationsForItemsBody = {
  readonly contentList: {
    readonly content: ReadonlyArray<DataQualityCertificationContentListItem>;
  };
}

export async function deleteDataQualityCertificationsForItems(params: DeleteDataQualityCertificationsForItemsParams): Promise<IResult> {
  const result = makeJsonRestApiRequest<DeleteDataQualityCertificationsForItemsBody, {}>({
    config: deleteDataQualityCertificationConfig,
    request: mapDeleteParamsToBody(params)
  });

  await delayPromise(ERROR_NOTIFYING_SERVER_RESPONSE_DELAY);
  return result;
}

function mapDeleteParamsToBody(params: DeleteDataQualityCertificationsForItemsParams): DeleteDataQualityCertificationsForItemsBody {
  return {
    contentList: {
      content: params.items.map(t => ({
        id: t.contentLuid,
        contentType: t.contentType
      } as DataQualityCertificationContentListItem))
    }
  };
}